import createIcon from '../../createIcon';

/**
 * @component @name Handyman
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNjg4NiAxOC42NjhMMTYuMzg4NiAxMy4zNjhIMTUuMzk4NkwxMi44NTg2IDE1LjkwOFYxNi44OThMMTguMTU4NiAyMi4xOThDMTguNTQ4NiAyMi41ODggMTkuMTc4NiAyMi41ODggMTkuNTY4NiAyMi4xOThMMjEuNjg4NiAyMC4wNzhDMjIuMDc4NiAxOS42OTggMjIuMDc4NiAxOS4wNTggMjEuNjg4NiAxOC42NjhaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTcuMzU4NiAxMC42ODhMMTguNzY4NiA5LjI3ODA1TDIwLjg4ODYgMTEuMzk4QzIyLjA1ODYgMTAuMjI4IDIyLjA1ODYgOC4zMjgwNSAyMC44ODg2IDcuMTU4MDVMMTcuMzQ4NiAzLjYxODA1TDE1LjkzODYgNS4wMjgwNVYyLjIwODA1TDE1LjIzODYgMS40OTgwNUwxMS42OTg2IDUuMDM4MDVMMTIuNDA4NiA1Ljc0ODA1SDE1LjIzODZMMTMuODI4NiA3LjE1ODA1TDE0Ljg4ODYgOC4yMTgwNUwxMS45OTg2IDExLjEwOEw3Ljg2ODU1IDYuOTc4MDVWNS41NTgwNUw0Ljg0ODU1IDIuNTM4MDVMMi4wMTg1NSA1LjM2ODA1TDUuMDQ4NTUgOC4zOTgwNUg2LjQ1ODU1TDEwLjU4ODYgMTIuNTI4TDkuNzM4NTUgMTMuMzc4SDcuNjE4NTVMMi4zMTg1NSAxOC42NzhDMS45Mjg1NSAxOS4wNjggMS45Mjg1NSAxOS42OTggMi4zMTg1NSAyMC4wODhMNC40Mzg1NSAyMi4yMDhDNC44Mjg1NSAyMi41OTggNS40NTg1NSAyMi41OTggNS44NDg1NSAyMi4yMDhMMTEuMTQ4NiAxNi45MDhWMTQuNzg4TDE2LjI5ODYgOS42MzgwNUwxNy4zNTg2IDEwLjY4OFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Handyman = createIcon('Handyman', [
  [
    'path',
    {
      d: 'M21.6886 18.668L16.3886 13.368H15.3986L12.8586 15.908V16.898L18.1586 22.198C18.5486 22.588 19.1786 22.588 19.5686 22.198L21.6886 20.078C22.0786 19.698 22.0786 19.058 21.6886 18.668Z',
      key: 'ohfu4v',
    },
  ],
  [
    'path',
    {
      d: 'M17.3586 10.688L18.7686 9.27805L20.8886 11.398C22.0586 10.228 22.0586 8.32805 20.8886 7.15805L17.3486 3.61805L15.9386 5.02805V2.20805L15.2386 1.49805L11.6986 5.03805L12.4086 5.74805H15.2386L13.8286 7.15805L14.8886 8.21805L11.9986 11.108L7.86855 6.97805V5.55805L4.84855 2.53805L2.01855 5.36805L5.04855 8.39805H6.45855L10.5886 12.528L9.73855 13.378H7.61855L2.31855 18.678C1.92855 19.068 1.92855 19.698 2.31855 20.088L4.43855 22.208C4.82855 22.598 5.45855 22.598 5.84855 22.208L11.1486 16.908V14.788L16.2986 9.63805L17.3586 10.688Z',
      key: 'h4y4xq',
    },
  ],
]);

export default Handyman;
